export default "__VITE_ASSET__CoH7QnHC__"